import { render, staticRenderFns } from "./PreFContrato.vue?vue&type=template&id=5238311c&scoped=true&"
import script from "./PreFContrato.vue?vue&type=script&lang=js&"
export * from "./PreFContrato.vue?vue&type=script&lang=js&"
import style0 from "./PreFContrato.vue?vue&type=style&index=0&id=5238311c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238311c",
  null
  
)

export default component.exports